import { Content } from '@phrasee/phrasee-typings'
import { useMutation } from '@tanstack/react-query'
import { useQueryClient } from '@tanstack/react-query'

import { getIsPersonalized } from 'features/unifiedFlow/contentPage/helpers'

import { tweakVariant } from '../api'
import { isComponentElement } from '../interfaces'
import { contentKeys } from '../queryKeys'

const useTweakVariantMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(tweakVariant, {
    onMutate: (variables) => {
      const { variantId } = variables
      if (variantId) {
        queryClient.setQueryData(
          contentKeys.content(variables.contentId),
          (old: Content | undefined) => {
            if (!old) {
              return old
            }
            return {
              ...old,
              elements: old.elements.map((element) => {
                if (isComponentElement(element) && getIsPersonalized(element)) {
                  if (element.element_id !== variables.elementId) {
                    return element
                  }
                  return {
                    ...element,
                    personalized_variants: element.personalized_variants?.map(
                      (variant) =>
                        variant.variant_id === variantId
                          ? { ...variant, isLoading: true }
                          : variant
                    ),
                  }
                }

                return element
              }),
            }
          }
        )
      }
    },
  })
}

export default useTweakVariantMutation
